import React from "react";
import { ShieldCheck, ChevronLeft } from "lucide-react";

export default function Privacy({ onBack }) {
  return (
    <div className="min-h-screen bg-black text-zinc-400 font-mono p-8 max-w-3xl mx-auto">
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-green-500 hover:text-white mb-8 uppercase text-xs"
      >
        <ChevronLeft size={16} /> Back to the Street
      </button>

      <div className="border-l-4 border-blue-600 pl-6 mb-12">
        <ShieldCheck size={48} className="text-blue-500 mb-4" />
        <h1 className="text-4xl font-black italic text-white uppercase">
          Privacy Policy
        </h1>
        <p className="text-xs text-zinc-600 mt-2 tracking-widest uppercase">
          Your Data, Your Business
        </p>
      </div>

      <div className="space-y-8 text-sm leading-relaxed">
        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            1. Data Collection
          </h2>
          <p>
            We collect only what is necessary: your username (encrypted) and
            your password (hashed). We do not request your real name, address,
            or phone number. Keep it anonymous.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">2. Usage Logs</h2>
          <p>
            We log IP addresses to prevent multi-accounting and DDoS attacks.
            This data is for security purposes only and is periodically purged.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">3. Cookies</h2>
          <p>
            We use local storage (similar to cookies) to keep you logged in. No
            third-party tracking scripts are allowed on this block.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            4. Third Parties
          </h2>
          <p>
            We do not sell your intel to anyone. The Feds aren't getting
            anything from us unless required by law in the jurisdiction of
            Fallox Developments.
          </p>
        </section>
      </div>
    </div>
  );
}
